const twigAdminDashboardUrl = '/twig-admin-dashboard';

export default twigAdminDashboardUrl;
